import React, {useState} from "react"
import {Button, Form, InputNumber, message, Modal, Result, Select, Skeleton, Space} from "antd"
import {withRouter} from "react-router-dom"
import {editGrouponGift, fetchCategoryList, fetchCommodityList, fetchStoreList} from "../../../../../api/groupon"
import {useGroupBuyingContext} from "../../../store/useGroupBuyingContext"


const GroupBuyingEditGift = ({gifts, grouponId}) => {

    const {grouponListState} = useGroupBuyingContext()

    const [isLoading, setIsLoading] = useState(false)
    const [isShow, setIsShow] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errMsg, setErrMsg] = useState('')
    const [storeOption, setStoreOption] = useState([])
    const [categoryOption, setCategoryOption] = useState([])
    const [commodityOptions, setCommodityOptions] = useState([])

    const [form] = Form.useForm()

    const getStoreList = async () => {
        await fetchStoreList().then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
                return
            }
            const options = res.data.map(item => ({
                value: item.id,
                label: item.name,
                isLeaf: false
            }))
            setStoreOption(options)
        }).catch(err => {
            setIsError(true)
            setErrMsg(err.message)
        })
    }

    const getCategoryList = async () => {
        await fetchCategoryList().then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
                return
            }
            const options = res.data.map(item => ({
                value: item.id,
                label: item.name,
                isLeaf: false
            }))
            setCategoryOption(options)
        }).catch(err => {
            setIsError(true)
            setErrMsg(err.message)
        })
    }

    const getCommodityList = async (key) => {
        const gifts = form.getFieldValue('gifts')
        const {store, category} = gifts[key]
        if (!category || !store) {
            return
        }
        const params = {
            storeId: store,
            categoryId: category,
        }
        await fetchCommodityList(params).then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
                return
            }
            setCommodityOptions(prevState => {
                const options = res.data.map(item => ({
                    value: item.id,
                    label: item.name
                }))
                return {
                    ...prevState,
                    [key]: options
                }
            })
            console.log(commodityOptions)
        }).catch(err => {
            setIsError(true)
            setErrMsg(err.message)
        })
    }

    const updateGifts = async () => {
        try {
            const gifts = form.getFieldsValue().gifts
            const newGifts = gifts.map((item, index) => {
                const storeId = item.store
                const categoryId = item.category
                const commodityId = item.commodity
                const quantity = item.quantity
                const newItem = {
                    store: {
                        id: storeId,
                        name: storeOption.find(store => store.value === storeId).label
                    },
                    category: {
                        id: categoryId,
                        name: categoryOption.find(category => category.value === categoryId).label
                    },
                    commodity: {
                        id: commodityId,
                        name: commodityOptions[index].find(commodity => commodity.value === commodityId).label
                    },
                    quantity: quantity
                }
                if (item.id) {
                    newItem.id = item.id
                }
                return newItem
            })
            setIsLoading(true)
            await editGrouponGift({grouponIds: [grouponId], gifts: newGifts}).then(res => {
                if (res.status !== 1) {
                    throw new Error(res.detail)
                }
                setIsShow(false)
                message.success("编辑赠品成功")
                grouponListState.reFetch()
            })
        } catch (e) {
            message.error(`编辑赠品失败：${e.message}`)
        } finally {
            setIsLoading(false)
        }
    }

    const handleClick = async () => {
        form.resetFields()
        setIsShow(true)
        setIsLoading(true)
        await Promise.all([getStoreList(), getCategoryList(), initGifts()]).finally(() => {
            setIsLoading(false)
        })
    }

    const initGifts = async () => {
        try {
            const initData = await Promise.all(gifts.map(async (item, index) => {
                const storeId = item.store.id
                const categoryId = item.category.id
                const commodityId = item.commodity.id
                const res = await fetchCommodityList({storeId, categoryId})
                if (res.status !== 1) {
                    throw new Error(res.detail)
                }
                const options = res.data.map(item => ({
                    value: item.id,
                    label: item.name
                }))
                // Update commodityOptions state for each gift
                setCommodityOptions(prevState => ({
                    ...prevState,
                    [index]: options
                }))
                // Return the transformed gift object
                return {
                    store: storeId,
                    category: categoryId,
                    commodity: commodityId,
                    quantity: item.quantity,
                    id: item.id
                }
            }))

            form.setFieldsValue({gifts: initData})
        } catch (e) {
            console.error(e.message)
        }
    }

    const handleFinish = () => {
        updateGifts()
    }

    return (
        <div>
            <span onClick={handleClick}>编辑赠品</span>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={form.submit}
                title="编辑赠品"
                width={1000}
            >
                {isError ? <Result title={"获取赠品信息发生错误"} subTitle={errMsg}/> :
                    <Skeleton loading={isLoading} active>
                        <Form
                            form={form}
                            labelCol={{span: 8}}
                            wrapperCol={{span: 16}}
                            onFinish={handleFinish}
                        >
                            <Form.List name="gifts">
                                {(fields, {add, remove}) => (
                                    <div>
                                        <Form.Item>
                                            <Button onClick={() => add()} type="dashed">
                                                添加赠送商品
                                            </Button>
                                        </Form.Item>

                                        {fields.map(({key, name, ...restField}) => (
                                            <Space
                                                key={key}
                                                style={{display: 'flex', marginBottom: 8}}
                                                align="baseline"
                                            >
                                                <Form.Item
                                                    {...restField}
                                                    label="选择仓库"
                                                    name={[name, 'store']}
                                                    rules={[{required: true, message: '请选择仓库'}]}
                                                >
                                                    <Select options={storeOption} style={{width: 150}}
                                                            placeholder="请选择仓库"/>
                                                </Form.Item>

                                                <Form.Item
                                                    {...restField}
                                                    label="选择类型"
                                                    name={[name, 'category']}

                                                    rules={[{required: true, message: '请选择类型'}]}
                                                >
                                                    <Select options={categoryOption} style={{width: 150}}
                                                            placeholder="请选择类型"
                                                            onSelect={() => getCommodityList(key)}/>
                                                </Form.Item>
                                                <Form.Item
                                                    {...restField}
                                                    label="选择商品"
                                                    name={[name, 'commodity']}
                                                    rules={[{required: true, message: '请选择商品'}]}
                                                >
                                                    <Select options={commodityOptions[key]} style={{width: 150}}
                                                            placeholder="请选择商品"
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    {...restField}
                                                    label="数量"
                                                    name={[name, 'quantity']}
                                                    rules={[{required: true, message: '请输入数量'}]}
                                                >
                                                    <InputNumber placeholder="请输入数量"/>
                                                </Form.Item>
                                                <Form.Item>
                                                    {fields.length ? (
                                                        <Button onClick={() => remove(name)} type="dashed">
                                                            删除
                                                        </Button>
                                                    ) : null}
                                                </Form.Item>
                                            </Space>
                                        ))}
                                    </div>
                                )}
                            </Form.List>
                        </Form>
                    </Skeleton>}
            </Modal>
        </div>
    )
}

export default withRouter(GroupBuyingEditGift)


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingEdit/component/GroupBuyingEditGift.js